import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { API_URL } from '../../../service/config'

function Meta({
  description,
  lang,
  meta,
  title,
  files,
  tags,
  imgSrc
}) {

  const {
    site
  } = useStaticQuery(
    graphql `query {
      site {
        siteMetadata {
          title
          description
          author
        }
      }
    }`
  )

  const defaultTitle = site.siteMetadata?.title
  let pageTitle = defaultTitle || ''
  let canonicalUrl = tags?.canonicalUrl || ''
  console.log('dfdfdfdf====',tags)
  tags = tags?.metaTags || tags
  if(tags && tags.length){
    const found = tags ? tags.find(el => el.attributes.name === 'title') : null
    pageTitle = found ? found.attributes.content : defaultTitle
  }else{
    pageTitle = tags?.title || defaultTitle
  }
  
  const imageWidth = "256";
  const imageHeight = "256";
 // const imageSrc =  API_URL + (imgSrc ? imgSrc : "/assets/images/icons/Logo.svg");

  return (
    <Helmet
      defer={false}
      htmlAttributes = {
      {
        lang,
      }
    }>
      <meta charset = "utf-8" />
      <title key="title">{pageTitle}</title>
      <meta name = "viewport" content = "width=device-width, initial-scale=1, shrink-to-fit=no" />
      <meta name = "apple-mobile-web-app-capable" content = "yes" />
      <meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests"></meta>
      <meta name="apple-mobile-web-app-status-bar-style" content="black" />

      { 
      meta && meta.page === 'Homepage' ?
        <meta
        name={meta.name || ''}
        content={meta.content || ''}
      /> : null
      }

      {
        (tags && tags.length) &&
        tags.map((el, index) => {
          if (el.attributes.name !== null && el.attributes.content != null && el.attributes.name !== "title") {
            return (
              <meta
                key={index}
                name={el.attributes.name}
                content={el.attributes.content}
              />
            )
          }
          if (el.attributes.property !== null && el.attributes.content != null) {
            return (
              <meta
                key={index}
                property={el.attributes.property}
                content={el.attributes.content}
              />
            )
          }
        })
      }
      {console.log('tags&canonicalUrl---> ',tags, ' v==v ' ,canonicalUrl.canonical_url)}
      {/* (tags && (tags.length > 0 && canonicalUrl !== '' && canonicalUrl.canonical_url !== null)) &&  */}
      {
        (tags && (canonicalUrl !== '' && canonicalUrl.canonical_url !== null)) && 
          <link rel="canonical" href={canonicalUrl?.canonical_url} />
      }

      {
        (tags && (tags.length === 0 || tags.length === undefined)) &&
        Object?.keys(tags).map(function(key) {
          if(key === 'description'){
            return <meta name='description' content={tags.description} data-react-helmet="true" />
          }
          if(key === 'keywords'){
            return <meta name='keywords' content={tags.keywords} data-react-helmet="true" />
          }
          if(key === 'twitter_cards_site'){
            return <meta name='twitter:site' content={tags.twitter_cards_site} data-react-helmet="true" />
          }
          if(key === 'twitter_cards_description'){
            return <meta name='twitter:description' content={tags.twitter_cards_description} data-react-helmet="true" />
          }
          if(key === 'twitter_cards_title'){
            return <meta name='twitter:title' content={tags.twitter_cards_title} data-react-helmet="true" />
          }
          if(key === 'twitter_cards_creator'){
            return <meta name='twitter:creator' content={tags.twitter_cards_creator} data-react-helmet="true" />
          }
          if(key === 'twitter_cards_page_url'){
            return <meta name='twitter:url' content={tags.twitter_cards_page_url} data-react-helmet="true" />
          }
          if(key === 'twitter_cards_image'){
            return <meta name='twitter:image' content={tags.twitter_cards_image} data-react-helmet="true" />
          }
          if(key === 'twitter_cards_image_alt'){
            return <meta name='twitter:image:alt' content={tags.twitter_cards_image_alt} data-react-helmet="true" />
          }
          if(key === 'og_site_name'){
            return <meta property='og:site_name' content={tags.og_site_name} data-react-helmet="true" />
          }
          if(key === 'og_url'){
            return <meta property='og:url' content={tags.og_url} data-react-helmet="true" />
          }
          if(key === 'og_title'){
            return <meta property='og:title' content={tags.og_title} data-react-helmet="true" />
          }
          if(key === 'og_description'){
            return <meta property='og:description' content={tags.og_description} data-react-helmet="true" />
          }
          if(key === 'og_image'){
            return <meta property='og:image' content={tags.og_image} data-react-helmet="true" />
          }
          if(key === 'og_image_url'){
            return <meta property='og:image:url' content={tags.og_image_url} data-react-helmet="true" />
          }
          if(key === 'canonical_url'){
            return <link rel="canonical" href={tags.canonical_url} />
          }
        })
      }

      <link rel = "icon" type = "image/x-icon" href = "assets/images/favicon.ico" />
      <link rel = "apple-touch-icon" href = "assets/images/icons/icon_192x192.png" />

      <link href="/assets/css/bootstrap.min.css" rel="stylesheet"></link>
      <link href="/assets/css/slick.css" rel="stylesheet"></link>
      <link href="/assets/css/slick-theme.css" rel="stylesheet"></link>
      <link href="/assets/css/common.css" rel="stylesheet"></link>
      <link href="/assets/css/accessibility.css" rel="stylesheet"></link>
      {process.env.NODE_ENV === 'production' &&
        <script src="/assets/js/jquery-3.5.1.min.js"></script>
      }
      <script src="/assets/js/lazysizes.min.js"></script>
      <script src="/assets/js/slick.js"></script>
      <script src="/assets/js/bootstrap.bundle.min.js"></script>
      <script src="/assets/js/staging-bot.js"></script>
      <script src="/assets/js/common.js"></script>
      
      {files.css.map((el, index) => (
        <link key={index} href={el} rel="stylesheet" />
      ))}
      {files.js.map((el, index) => (
        <script key={index} src={el} ></script>
      ))}

      
    </Helmet>
  )
}

Meta.defaultProps = {
  lang: `en`,
  meta: [],
  files: {
    js: [],
    css: []
  },
  description: ``,
}

Meta.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
}

export default Meta
